/**
 * カレンダーの種別フィルタ
 *
 * 表示する種別の選択はビューを切り替えても引き継ぎたいので、localStorage に保存する。
 */

import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import type { CalendarEventType } from './components/calendar-event-builder'

export const CALENDAR_FILTER_ITEMS: { type: CalendarEventType; label: string; emoji: string }[] = [
  { type: 'visit', label: '滞在', emoji: '📍' },
  { type: 'movement', label: '移動', emoji: '🚶' },
  { type: 'sleep', label: '睡眠', emoji: '🌙' },
  { type: 'read', label: '読書', emoji: '📖' },
  { type: 'receipt', label: '買い物', emoji: '🧾' },
  { type: 'workout', label: '筋トレ', emoji: '🏋️' },
  { type: 'activity', label: '運動', emoji: '💪' },
  { type: 'todo', label: 'TODO', emoji: '✅' },
]

type CalendarFilterState = {
  /** 非表示にしている種別。空なら全表示 */
  hiddenTypes: CalendarEventType[]
  toggleType: (type: CalendarEventType) => void
  showAll: () => void
}

export const useCalendarFilterStore = create<CalendarFilterState>()(
  persist(
    (set) => ({
      hiddenTypes: [],
      toggleType: (type) =>
        set((state) => ({
          hiddenTypes: state.hiddenTypes.includes(type)
            ? state.hiddenTypes.filter((t) => t !== type)
            : [...state.hiddenTypes, type],
        })),
      showAll: () => set({ hiddenTypes: [] }),
    }),
    { name: 'activity-calendar-filter' },
  ),
)
